/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button, FilledInput, InputAdornment } from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";
import { SVGIcons } from "cms/icons/svg-icons";

const ComponentSearchBar = (props) => {

    const { isDisabled, searchTerm, setSearchTerm } = props;

    const clearSearch = () => {
        setSearchTerm("");
    };

    const handleChange = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <FilledInput
            className='component-search-bar'
            color='#F2F2F2'
            disabled={isDisabled}
            disableUnderline
            fullWidth
            startAdornment={
                <InputAdornment className='search-icon' position='start'>
                    <SVGIcons.common.Search />
                </InputAdornment>
            }
            endAdornment={
                searchTerm && searchTerm.length > 0 && (
                    <Button className='clear-search-button' onClick={clearSearch} position='end'>
                        <ClearIcon />
                    </Button>
                )
            }
            aria-describedby='component-search-text'
            placeholder='Search components'
            value={searchTerm}
            onChange={handleChange}
        />
    );
};

export { ComponentSearchBar };
